export var SignalInstalledStatus;
(function (SignalInstalledStatus) {
    SignalInstalledStatus["ACTIVE"] = "active";
    SignalInstalledStatus["INACTIVE"] = "inactive";
})(SignalInstalledStatus || (SignalInstalledStatus = {}));
export var SignalOriginType;
(function (SignalOriginType) {
    SignalOriginType["DEBRIEF"] = "DEBRIEF";
    SignalOriginType["FEEDBACK"] = "FEEDBACK";
    SignalOriginType["MANUAL"] = "MANUAL";
    SignalOriginType["EXTERNAL"] = "EXTERNAL";
})(SignalOriginType || (SignalOriginType = {}));
export var SignalVisibilityType;
(function (SignalVisibilityType) {
    SignalVisibilityType["PUBLIC"] = "PUBLIC";
    SignalVisibilityType["PRIVATE"] = "PRIVATE";
})(SignalVisibilityType || (SignalVisibilityType = {}));
export var ExternalSource;
(function (ExternalSource) {
    ExternalSource["WORD"] = "WORD";
    ExternalSource["DYNAMICS_CRM"] = "DYNAMICS_CRM";
})(ExternalSource || (ExternalSource = {}));
export var SignalApplicabilityScope;
(function (SignalApplicabilityScope) {
    SignalApplicabilityScope["SELF"] = "SELF";
    SignalApplicabilityScope["DIRECT_REPORTS"] = "DIRECT_REPORTS";
    SignalApplicabilityScope["FULL_HIERARCHY"] = "FULL_HIERARCHY";
})(SignalApplicabilityScope || (SignalApplicabilityScope = {}));
export var SignalCategory;
(function (SignalCategory) {
    SignalCategory["PLAYBOOK"] = "PLAYBOOK";
    SignalCategory["COMMITMENT"] = "COMMITMENT";
})(SignalCategory || (SignalCategory = {}));
/**
 * Persisted per-commitment lifecycle. Set by the commitment pipeline:
 * Apply writes the base value (`new` / `updated` / `deleted`); MarkMissed
 * overrides survivors of Filter to `miss`; `same` is a no-op write skip
 * except for the stale-miss clear path (see commitment-pipeline.md).
 *
 * Note: distinct from `CommitmentUpdateStatus` (the classifier verdict in
 * signal.responses.ts) — that's transient and uses `'deletion'`; this is
 * persisted lifecycle and uses `'deleted'`, plus adds `'miss'`.
 */
export var CommitmentState;
(function (CommitmentState) {
    CommitmentState["New"] = "new";
    CommitmentState["Same"] = "same";
    CommitmentState["Updated"] = "updated";
    CommitmentState["Miss"] = "miss";
    CommitmentState["Deleted"] = "deleted";
})(CommitmentState || (CommitmentState = {}));
export const SEVERITY_LABELS = {
    Low: 3,
    Medium: 5,
    High: 8,
    Critical: 10,
};
